/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_TrendInputs */

const en_us2_profile_editors_pain_trend = /** @type {(inputs: Profile_Editors_Pain_TrendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is it evolving?`)
};

const pt_br2_profile_editors_pain_trend = /** @type {(inputs: Profile_Editors_Pain_TrendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está evoluindo?`)
};

const es_419_profile_editors_pain_trend = /** @type {(inputs: Profile_Editors_Pain_TrendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo evoluciona?`)
};

const pt_pt2_profile_editors_pain_trend = /** @type {(inputs: Profile_Editors_Pain_TrendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está a evoluir?`)
};

const fr_fr2_profile_editors_pain_trend = /** @type {(inputs: Profile_Editors_Pain_TrendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment ça évolue ?`)
};

const de_de2_profile_editors_pain_trend = /** @type {(inputs: Profile_Editors_Pain_TrendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie entwickelt es sich?`)
};

const it_it2_profile_editors_pain_trend = /** @type {(inputs: Profile_Editors_Pain_TrendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come sta evolvendo?`)
};

/**
* | output |
* | --- |
* | "How is it evolving?" |
*
* @param {Profile_Editors_Pain_TrendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_trend = /** @type {((inputs?: Profile_Editors_Pain_TrendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_TrendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_trend(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_trend(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_trend(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_trend(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_trend(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_trend(inputs)
	return en_us2_profile_editors_pain_trend(inputs)
});
export { profile_editors_pain_trend as "profile-editors.pain_trend" }